import { colours } from "@affinity/constants/StyleConstants";
import { breakpointWidth, rem } from "@affinity/constants/StyleHelpers";
import styled from "styled-components";

export const SwipeNavContainer = styled.div`
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-flow: row nowrap;
    border-top: 1px solid ${colours.lightGreen50};
    border-bottom: 1px solid ${colours.lightGreen50};
    padding: ${rem(5)} 0;
    @media (min-width: ${breakpointWidth("lg")}) {
        padding: ${rem(10)} 0;
    }
    button:disabled {
        background: transparent !important;
        border: none !important;
    }
`;

export const SwipeNavWrap = styled.div`
    position: relative;
    overflow-y: hidden;
    scroll-behavior: smooth;
    scrollbar-width: none;
    -ms-overflow-style: none;
    flex-grow: 1;
    &::-webkit-scrollbar {
        display: none;
    }
`;

export const SwipeNavList = styled.ul`
    display: inline-flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    list-style: none;
    white-space: nowrap;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;
    max-width: none;
    min-width: 100%;
`;

export const SwipeNavLeftButton = styled.button`
    background: none;
    border: none;
    padding: ${rem(1)} ${rem(9)};
    margin-left: -${rem(16)};
    color: ${colours.darkBlue};
    pointer-events: all;
    cursor: pointer;
`;

export const SwipeNavRightButton = styled.button`
    background: none;
    border: none;
    padding: ${rem(1)} ${rem(9)};
    margin-right: -${rem(16)};
    color: ${colours.darkBlue};
    pointer-events: all;
    cursor: pointer;
`;

export const SwipeNavButton = styled.button`
    font-family: inherit;
    margin: 0;
    background: none;
    border: none;
    font-size: ${rem(14)};
    line-height: 1;
    font-weight: 500;
    padding: ${rem(10)};
    color: ${colours.black};
    pointer-events: all;
    cursor: pointer;
    @media (min-width: ${rem(1280)}) {
        font-size: ${rem(16)};
        line-height: 1;
    }
    span {
        display: block;
        font-weight: 600;
        padding: ${rem(8)} ${rem(10)};
        border: 2px solid ${colours.lightGreen};
        background-color: ${colours.lightGreen};
        border-radius: 100px;
    }
    &:hover span {
        background-color: ${colours.white};
    }
`;
